import React from 'react';
import Container from '../../atoms/Container';
import CollapsablePlansList from './collapsable-plans-list';
import { ContainerHeader } from './components';
import { eventParamAttributes, } from '@spotify-internal/touchdown-analytics';
import { purify } from '../../utils/helpers';
const CollapsablePlans = ({ header, data, container, eventParams, }) => {
    return (React.createElement(Container, Object.assign({}, container, eventParamAttributes(eventParams)),
        header && (React.createElement(ContainerHeader, { variant: "heading2", dangerouslySetInnerHTML: { __html: purify(header.text) } })),
        data &&
            data.map((plan, i) => (React.createElement(CollapsablePlansList, { key: `collapsable-plans-${i}`, plan: plan })))));
};
export default CollapsablePlans;
//# sourceMappingURL=collapsable-plans.js.map